import { Component, OnInit } from '@angular/core';
import { faAngleRight
 } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-durham-facility-rentals',
  templateUrl: './durham-facility-rentals.component.html',
  styleUrls: ['./durham-facility-rentals.component.scss']
})
export class DurhamFacilityRentalsComponent implements OnInit {
  faAngelRight = faAngleRight;

  constructor() { }

  ngOnInit(): void {
  }

}
